export default __webpack_public_path__ + "static/media/netlify.ccce5884.png";